const SUBSCRIPTION_TYPES = {
    SAME_DAY_UNLIMITED: 'SDU',
    AUTO_REPLENISHMENT: 'REPLENISHMENT'
};

export default { SUBSCRIPTION_TYPES };
